import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {
    Prescription,
    setAction,
    reinitAction,
} from 'one-state-prescription';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';

import {
    SETSELECTED,
    RESET,
    SET,
} from 'one-state-subject/src/types';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    addAction
} from 'one-state-error/src/actions';
import { InvokeFinesseProxy } from '../../subject/src/index';
import { Disposition } from 'one-model-local';

export const enum Types {
    PRESCRIPTION = 'prescription-select',
    PRESCRIPTIONCLEAR = 'prescription-clear',
}
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

function sortFunction(a: Prescription, b: Prescription) {
// Sort by prescription status
  if (a.prescriptionstatus === "Active" && b.prescriptionstatus !== "Active") {
    return -1; // "Active" prescriptions come first
  } else if (a.prescriptionstatus !== "Active" && b.prescriptionstatus === "Active") {
    return 1; // "Active" prescriptions come first
  } else {
    // If statuses are the same or both are not "Active", sort by date
    const dateA = new Date(a.startdate);
    const dateB = new Date(b.startdate);
    return dateA > dateB ? 1 : -1;
  }
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });


const pushToSkeleton = (payload: any) => setSkeletonAction(payload);

export const fetchPrescriptionEpic = (context: any) => (
    (action$: any,state$:any) => {
        const { server,agentId, teamName, alertnotification, settings: { servers, compatible, epicendpoints: { patientprescription, apitoken } }, log } = context;
        const { finesse_proxy_service,contact_center_type } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(SETSELECTED),
            mergeMap((action: any) => {
                var dataresponse = action.payload;

                const getRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            //"PatientID": datares?.id
                            "patientMRN": datares.prescriptionMRNData,
                            //"prescriptionId":"A6000420"
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(patientprescription, data, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            response = server.post({
                                path: patientprescription,
                                data: data,
                                headers: headers
                            })
                                .then((responsedata: any) => responsedata).catch((responseerror: any) => {
                                    log.error(
                                        'ccw-gadget-prescription-epic',
                                        'fetch-prescription-epic', {
                                        responseerror
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "Prescription",
                                        type: "error",
                                        status: responseerror?.status,
                                        erroritems: responseerror?.errors
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,prescription-epic",
                                "fetch-fetchPrescription-epic", {
                                response
                            });
                        }
                        return from(response)
                    }
                    else {
                        return from([]);
                    }

                }

                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context)))
                    .pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.prescriptiondata)
                            ];

                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1007" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                disp.meta03 = response?.error?.status;
                                disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                                actions.push(pushToDisposition(disp));
                            }
                            else {
                                let disp: Disposition = { value: "190" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  }  else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                actions.push(pushToDisposition(disp));
                            }
                            // clear skeleton for prescription
                            let skeletonPrescription: Skeleton = {
                                prescription_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonPrescription));
                            return actions;
                        })
                    )
            })
        )
    }
);

export const pushClearPrescription = (context: any) => (
    (action$: any) => {
        return action$.pipe(
            ofType(SET, RESET),
            map(action => reinitAction()
        ))
    }
);

const TransformResponse = (response: any, context: any) => {
    const { log } = context;
    log.debug(
        'ccw-gadget-prescription-transformation-request',
        response);
    let prescriptiondata: Prescription[] = [];
    let result: any = {
        prescriptiondata: prescriptiondata,
        error: undefined
    }
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
    if(response?.length > 0) {
        let deliverytyperarray:any = [];
        response.forEach((presele:any) => {
            if(presele?.Prescriptions?.Prescription?.length > 0) {
                presele.Prescriptions.Prescription.forEach((dataele:any)=>{
                    let prescription: Prescription = {
                        startdate: "",
                        medication: "",
                        prescriptionstatus: "",
                        fillsremaining:"",
                        authorizingprovider:"",
                        transmissionmethod:"",
                        deacodenumber:"",
                        deliverytype:[],
                        hasfillinprogress:"",
                        isfillable:"",
                        ispartialfillremain:"",
                        lastrefillamount:"",
                        lastrefilldate:"",
                        pickuppharmacyid:"",
                        prescriptionid:"",
                        defaultdelivery: "",
                        streetvalue:"",
                        statevalue:"",
                        cityvalue:"",
                        pincodevalue: "",
                        patientsig: "",
                        enddate:"",
                        deliverymethod:"",
                        pickuppharmacyname:""
                    }
                    if(presele?.Patient) {
                        prescription.streetvalue = presele.Patient.StreetAddress ? presele.Patient.StreetAddress : "";
                        prescription.cityvalue = presele.Patient.City ? presele.Patient.City : "";
                        prescription.statevalue = presele.Patient.State ? presele.Patient.State : "";
                        prescription.pincodevalue = presele.Patient.ZipCode ? presele.Patient.ZipCode : "";
                        prescription.deliverymethod = presele.Patient.PreferredDeliveryMethod ? presele.Patient.PreferredDeliveryMethod : "";
                    }
                    deliverytyperarray = []
                    if(dataele?.OwningPharmacy?.AvailableDeliveryMethods?.DeliveryMethod?.length > 0) {
                        //prescription.deliverytype = dataele.OwningPharmacy.AvailableDeliveryMethods.DeliveryMethod ? dataele.OwningPharmacy.AvailableDeliveryMethods.DeliveryMethod : [];
                        if(dataele?.OwningPharmacy?.AvailableDeliveryMethods?.DeliveryMethod?.length > 0) {
                            dataele.OwningPharmacy.AvailableDeliveryMethods.DeliveryMethod.forEach((typeele:any)=>{
                                if(typeele !== "Courier") {
                                    deliverytyperarray.push(typeele)
                                    prescription.deliverytype = deliverytyperarray ? deliverytyperarray : [];
                                }
                            })
                        }
                        prescription.defaultdelivery = dataele?.Fills?.Fill?.DeliveryMethod ? dataele.Fills.Fill.DeliveryMethod : "";
                        prescription.pickuppharmacyid = dataele?.Fills?.Fill?.PickupPharmacyNCPDPId ? dataele.Fills.Fill.PickupPharmacyNCPDPId : "";
                        prescription.pickuppharmacyname = dataele?. Fills?.Fill?.PickupPharmacyDisplayName ? dataele.Fills.Fill.PickupPharmacyDisplayName : "";
                    }
                    prescription.medication = dataele?.Medication ? dataele.Medication : "";
                    prescription.startdate = dataele?.StartDate ? dataele.StartDate : "";
                    prescription.prescriptionstatus = dataele?.Status ? dataele.Status : "";
                    prescription.fillsremaining = dataele?.FillsRemaining ? dataele.FillsRemaining : "";
                    prescription.authorizingprovider = dataele?.AuthorizingProviderDisplayName ? dataele.AuthorizingProviderDisplayName : "";
                    prescription.transmissionmethod= "";
                    prescription.deacodenumber = dataele?.DEACodeNumber ? dataele.DEACodeNumber : "";
                    prescription.hasfillinprogress = dataele?.HasFillInProgress ? dataele.HasFillInProgress : "";
                    prescription.isfillable = dataele?.IsFillable ? dataele.IsFillable : "";
                    prescription.ispartialfillremain = dataele?.IsPartialFillRemaining ? dataele.IsPartialFillRemaining : "";
                    prescription.lastrefillamount = dataele?.LastDispensedDaySupply ? dataele.LastDispensedDaySupply : "";
                    prescription.lastrefilldate = dataele?.LastDispensed ? dataele.LastDispensed : "";
                    prescription.prescriptionid = dataele?.Id ? dataele.Id : "";
                    prescription.patientsig = dataele?.Sig ? dataele.Sig : "";
                    prescription.enddate = dataele?.EndDate ? dataele.EndDate : "";
                    prescriptiondata.push(prescription);
                })
                prescriptiondata.sort(sortFunction)
            }
        });
    }
    result.prescriptiondata = prescriptiondata;
    log.debug(
        'ccw-gadget-prescription-transformation-response',
        result);
    return result;
}